// @ts-ignore
import { Options, PFF } from '../js-segment-annotator-code/pff';
import { AbstractAlgorithmAdapter } from './abstract-algorithm-adapter';

export class PFFAdapter extends AbstractAlgorithmAdapter<Options> {
  readonly name = 'PFF';

  get minRelativeSize() {
    return -6; // played a little ... this is still a bit arbitrary
  }

  get maxRelativeSize() {
    return 6; // played a little ... this is still a bit arbitrary
  }

  protected executeAlgorithm(options: Options) {
    // @ts-ignore
    return new PFF(this.image, options).result;
  }

  protected defaultOptions() {
    // The paper that presented this algorithm showed examples with 128x128
    // images, and 320x240 images. For both they used sigma = 0.8. For the
    // smaller they used k = 150, and the bigger k = 300. They also had one
    // slightly bigger image that used the same parameters as the other bigger
    // ones. That seems close-ish to this generalization based on image size.
    // http://people.cs.uchicago.edu/~pff/papers/seg-ijcv.pdf
    return { sigma: 0.8, threshold: Math.sqrt(this.imageArea) };
  }

  protected adjustForSmallerSuperpixels({ sigma, threshold }: Options) {
    return {
      sigma: sigma / Math.sqrt(2),
      threshold: threshold / Math.sqrt(2),
    };
  }

  protected adjustForBiggerSuperpixels({ sigma, threshold }: Options) {
    return {
      sigma: sigma * Math.sqrt(2),
      threshold: threshold * Math.sqrt(2),
    };
  }
}
